import React from 'react';
import Grid from '@mui/material/Grid';
import Icon from '@mui/material/Icon';
import { CachedOutlined, ErrorOutline, HelpOutline, Assignment } from '@mui/icons-material';
import { StorageRounded, CheckCircle, AccountTree, GroupWork } from '@mui/icons-material';
import { ViewComfyRounded, PlaylistAddCheck, LabelRounded } from '@mui/icons-material';
import hubTaskImg from '../../../Images/icons/hubTask.png';
import RequiredGreyIcon from '../../../Images/icons/RequiredGrey.svg';
import RequiredRedIcon from '../../../Images/icons/RequiredRed.svg';
import { ReactComponent as Calculator } from '../../../Images/icons/calculator.svg';
import { blue, cyan, amber, grey } from '@mui/material/colors';
import { HUB_COLORS } from '../../../constants';
import Iconify from '../../iconify/index';

export { ReactComponent as MicrosoftIcon } from '../../../Images/icons/ms-symbollockup_signin_dark.svg';
export { ReactComponent as Microsoft365Icon } from '../../../Images/icons/microsoft.svg';
export { ReactComponent as DroidIcon } from '../../../Images/icons/driod.svg';

export const TaskIcon = ({ style, ...props }) => (
  <Grid style={{ display: 'flex' }} {...props}>
    <Iconify icon="solar:case-round-minimalistic-bold-duotone" style={{ color: HUB_COLORS.work, ...style }} />
  </Grid>
);

export const ReadUnderstoodIcon = (props) => <PlaylistAddCheck sx={{ color: blue[500] }} {...props} />;

export const FormIcon = ({ style, ...props }) => (
  <Iconify icon="solar:clipboard-list-bold-duotone" style={{ color: HUB_COLORS.form, ...style }} {...props} />
);

export const DocIcon = ({ style, ...props }) => (
  <Iconify icon="solar:documents-bold-duotone" style={{ color: HUB_COLORS.doc, ...style }} {...props} />
);

export const ProcessIcon = ({ style, ...props }) => (
  <Iconify icon="solar:cpu-bolt-line-duotone" style={{ color: HUB_COLORS.process, ...style }} {...props} />
);

export const HubIcon = ({ style, ...props }) => (
  <Grid style={{ display: 'flex', ...style }} {...props}>
    <img src={hubTaskImg} alt="img" style={{ height: 24, width: 24 }} />
  </Grid>
);

export const AuditIcon = ({ style, ...props }) => (
  <Iconify icon="solar:checklist-minimalistic-bold-duotone" style={{ color: HUB_COLORS.audit, ...style }} {...props} />
);

export const KPIHubIcon = ({ style, ...props }) => (
  <Iconify icon="solar:pie-chart-2-bold-duotone" style={{ color: HUB_COLORS.kpi, ...style }} {...props} />
);

export const ResourcesIcon = ({ style, ...props }) => (
  <Iconify icon="solar:cart-4-bold-duotone" style={{ color: 'grey', ...style }} {...props} />
);

export const ProjectIcon = ({ style, ...props }) => (
  <AccountTree style={{ color: 'darkorange', ...style }} {...props} />
);

export const ReoccurringIcon = ({ style, ...props }) => (
  <CachedOutlined style={{ color: 'grey', ...style }} {...props} />
);

export const RiskIcon = ({ style, ...props }) => <ErrorOutline style={{ color: 'grey', ...style }} {...props} />;

export const SupportIcon = ({ style, ...props }) => <HelpOutline style={{ color: 'grey', ...style }} {...props} />;

export const RequiredIcon = ({ style, ...props }) => (
  <Grid style={{ display: 'flex', ...style }} {...props}>
    <img src={RequiredRedIcon} alt="img" style={{ height: 20, width: 20 }} />
  </Grid>
);

export const RequiredGrey = ({ style, ...props }) => (
  <Grid style={{ display: 'flex', ...style }} {...props}>
    <img src={RequiredGreyIcon} alt="img" style={{ height: 20, width: 20 }} />
  </Grid>
);

export const CalculatorIcon = ({ style, ...props }) => (
  <Grid style={{ display: 'flex', ...style }} {...props}>
    <Calculator style={{ height: 20, width: 20, fill: style?.color || grey[600] }} />
  </Grid>
);

export const ApprovalIcon = ({ style, ...props }) => <CheckCircle style={{ color: blue[600], ...style }} {...props} />;

export const RoutineIcon = ({ style, ...props }) => <Assignment style={{ color: blue[900], ...style }} {...props} />;

export const DataIcon = ({ style, ...props }) => <StorageRounded style={{ color: blue[900], ...style }} {...props} />;

export const AssetIcon = ({ style, ...props }) => (
  <Iconify icon="solar:sledgehammer-bold-duotone" style={{ color: HUB_COLORS.asset, ...style }} {...props} />
);

export const TeamIcon = ({ style, color = cyan[600], ...props }) => (
  <GroupWork color={color} style={{ ...style }} {...props} />
);

export const RegistersIcon = ({ style, ...props }) => (
  <Iconify icon="si:grid-on-duotone" style={{ color: HUB_COLORS.register, ...style }} {...props} />
);

export const MSIcon = ({ name, styles = {}, mini }) => (
  <Icon sx={styles} className={`ms-Icon ms-Icon--${name} ${mini ? 'ms-Icon-mini' : ''}`}></Icon>
);

export const WorkspaceIcon = ({ style, color = blue[700], ...props }) => (
  <ViewComfyRounded color={color} style={{ ...style }} {...props} />
);

export const PortalIcon = ({ style, ...props }) => (
  <Iconify icon="solar:earth-bold-duotone" style={{ color: blue[600], ...style }} {...props} />
);

export const FieldIcon = ({ style, ...props }) => <LabelRounded style={{ color: amber[500], ...style }} {...props} />;

export const HomeIcon = ({ style, ...props }) => (
  <Iconify icon="solar:home-smile-angle-bold" style={{ ...style }} {...props} />
);

export const FaceIcon = ({ style, ...props }) => (
  <Iconify icon="solar:face-scan-circle-bold-duotone" style={{ ...style }} {...props} />
);

export const AddIcon = ({ style, ...props }) => (
  <Iconify icon="solar:add-square-bold-duotone" style={{ ...style }} {...props} />
);

export const VideosIcon = ({ style, ...props }) => (
  <Iconify icon="solar:video-library-bold-duotone" style={{ ...style }} {...props} />
);

export const FAQIcon = ({ style, ...props }) => (
  <Iconify icon="solar:help-bold-duotone" style={{ ...style }} {...props} />
);

export const TicketsIcon = ({ style, ...props }) => (
  <Iconify icon="solar:ticker-star-bold-duotone" style={{ ...style }} {...props} />
);

export const TurtorialIcon = ({ style, ...props }) => (
  <Iconify icon="solar:notebook-bookmark-bold-duotone" style={{ ...style }} {...props} />
);

export const FeatureIcon = ({ style, ...props }) => (
  <Iconify icon="solar:code-file-bold-duotone" style={{ ...style }} {...props} />
);

export const TopPlaceIcon = ({ style, ...props }) => (
  <Iconify icon="solar:cup-first-bold-duotone" style={{ ...style }} {...props} />
);

export const UpdateIcon = ({ style, ...props }) => (
  <Iconify icon="solar:server-square-update-bold-duotone" style={{ ...style }} {...props} />
);

export const PodcastsIcon = ({ style, ...props }) => (
  <Iconify icon="solar:podcast-bold-duotone" style={{ ...style }} {...props} />
);

export const QnAIcon = ({ style, ...props }) => <Iconify icon="flat-color-icons:faq" style={{ ...style }} {...props} />;
export const ImprovementIcon = ({ style, ...props }) => (
  <Iconify icon="ic:twotone-tips-and-updates" style={{ ...style }} {...props} />
);

export const CalendarIcon = ({ style, ...props }) => (
  <Iconify icon="solar:calendar-bold" style={{ ...style }} {...props} />
);

export const UserIcon = ({ style, ...props }) => (
  <Iconify icon="solar:user-bold-duotone" style={{ ...style }} {...props} />
);

export const NotificationIcon = ({ style, ...props }) => (
  <Iconify icon="si:notifications-alt-duotone" style={{ ...style }} {...props} />
);

export const SuperAdminIcon = ({ style, ...props }) => (
  <Iconify icon="wpf:administrator" style={{ ...style }} {...props} />
);

export const NoticeIcon = ({ style, ...props }) => (
  <Iconify icon="solar:notes-minimalistic-bold-duotone" style={{ ...style }} {...props} />
);

export const FileIcon = ({ style, ...props }) => (
  <Iconify icon="solar:file-bold-duotone" style={{ ...style }} {...props} />
);

export const AddForAdminsIcon = ({ style, ...props }) => (
  <Iconify icon="solar:cat-bold-duotone" style={{ ...style }} {...props} />
);

export const DeleteIcon = ({ style, ...props }) => (
  <Iconify icon="icon-park-twotone:delete-five" style={{ ...style }} {...props} />
);

export const EditIcon = ({ style, ...props }) => (
  <Iconify icon="solar:clapperboard-edit-bold-duotone" style={{ ...style }} {...props} />
);

export const EyeIcon = ({ style, ...props }) => (
  <Iconify icon="solar:eye-bold-duotone" style={{ ...style }} {...props} />
);

export const ReferenceIcon = ({ style, ...props }) => (
  <Iconify icon="carbon:term-reference" style={{ ...style }} {...props} />
);

export const QuickActionIcon = ({ style, ...props }) => (
  <Iconify icon="solar:quit-pip-bold-duotone" style={{ ...style }} {...props} />
);

export const AssetManagementTaskIcon = ({ style, ...props }) => (
  <Iconify icon="tabler:asset" style={{ ...style }} {...props} />
);

export const AssetWorkIcon = ({ style, ...props }) => (
  <Iconify icon="hugeicons:new-job" style={{ ...style }} {...props} />
);

export const AssetMovementIcon = ({ style, ...props }) => (
  <Iconify icon="carbon:asset-movement" style={{ ...style }} {...props} />
);

export const AssetScheduleIcon = ({ style, ...props }) => (
  <Iconify icon="mdi:book-schedule" style={{ ...style }} {...props} />
);

export const CheckFielcIcon = ({ style, ...props }) => (
  <Iconify icon="ic:twotone-check-box" style={{ ...style }} {...props} />
);

export const FileCloudIcon = ({ style, ...props }) => (
  <Iconify icon="solar:cloud-file-bold-duotone" style={{ ...style }} {...props} />
);

export const ActionIcon = ({ style, ...props }) => (
  <Iconify icon="solar:clipboard-check-bold-duotone" style={{ ...style }} {...props} />
);

export const ArrowRightIcon = ({ style, ...props }) => (
  <Iconify icon="solar:map-arrow-right-bold-duotone" style={{ ...style }} {...props} />
);

export const QuestionMarkIcon = ({ style, ...props }) => (
  <Iconify icon="solar:question-circle-bold-duotone" style={{ ...style }} {...props} />
);

export const ExternalUserIcon = ({ style, ...props }) => (
  <Iconify icon="solar:user-circle-bold-duotone" style={{ ...style }} {...props} />
);

export const TrackerIcon = ({ style, ...props }) => (
  <Iconify icon="material-symbols:eye-tracking-outline-rounded" style={{ ...style }} {...props} />
);
